import * as React from "react";
import { FilterByIcon } from "src/components/FilterByIcon";
import { usePopupContext } from "src/hooks/usePopup";
import { Clause } from "./Clause";
import {
  FilterConditionPanel,
  FilterInputValue,
  conditionToInputType,
} from "./FilterConditionPanel";

// Pill component that displays the current value
function FilterPill({ data }: { data: FilterInputValue }) {
  return (
    <span>
      {data.field && (
        <>
          <span style={{ opacity: 0.65 }}>{data.field.target}.</span>
          <span>{data.field.attribute}</span>
          {data.operator && (
            <>
              <span style={{ opacity: 0.5 }}> </span>
              <span>{data.operator} </span>
            </>
          )}
          {data.values?.length && <span>{data.values.join(", ")}</span>}
        </>
      )}
    </span>
  );
}

export function FilterConditionClause({
  clause,
  value,
  updateClause,
  removeClause,
  sameAsLast,
}: {
  clause: any;
  value: any;
  updateClause: (clause: any) => void;
  removeClause: (clause: any) => void;
  sameAsLast?: boolean;
}) {
  const popup = usePopupContext();
  const data = React.useMemo(
    () => conditionToInputType(clause.value),
    [clause.value]
  );

  const handleApply = (newData: FilterInputValue) => {
    if (newData.field && newData.operator && newData.values?.length) {
      updateClause({
        ...clause,
        value: {
          ...newData.field,
          comparison: {
            [newData.operator]: newData.values,
          },
        },
      });
    }
    popup.close();
  };

  return (
    <Clause
      onRemove={() => removeClause(clause)}
      onMenuClose={() => popup.close()}
      renderMenu={() => (
        <FilterConditionPanel
          initialValue={data}
          onApply={handleApply}
          onCancel={() => popup.close()}
          value={value}
          removeClause={removeClause}
        />
      )}
      clause={clause}
      title={sameAsLast ? "" : "Filters"}
      icon={
        sameAsLast ? undefined : (
          <FilterByIcon size={10} style={{ opacity: 0.7 }} />
        )
      }
    >
      <FilterPill data={data} />
    </Clause>
  );
}
